import { useState } from "react";
import { Lead } from "../../../../../interfaces";

interface CheckedLead {
  idLead: string;
  idLeadCorretor: string;
  idCorretorLead?: string;
}

export function useCheckSelection(leads: Lead[]) {
  const [active, setActive] = useState(false);
  const [checked, setChecked] = useState<CheckedLead[]>([]);
  const [checkedState, setCheckedState] = useState<boolean[]>(
    new Array(leads?.length).fill(false)
  );
  // Indica que o usuário optou por transferir TODOS os leads da carteira
  // (todas as páginas), e não apenas os ids selecionados na página atual.
  // Só é ativado explicitamente pelo banner — qualquer alteração na seleção
  // o desliga para evitar envio acidental.
  const [allPagesSelected, setAllPagesSelected] = useState(false);

  const addRemoveCheck = (index: number, lead: CheckedLead) => {
    setAllPagesSelected(false);
    const updatedState = checkedState.map((item, i) =>
      i === index ? !item : item
    );
    setCheckedState(updatedState);
    setActive(!updatedState.includes(false));

    if (checked.some((obj) => obj.idLead === lead.idLead)) {
      setChecked((prev) => prev.filter((item) => item.idLead !== lead.idLead));
    } else {
      setChecked((prev) => [...prev, lead]);
    }
  };

  const handleCheckAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Marcar o header seleciona apenas a página atual. A intenção de
    // transferir todas as páginas é confirmada separadamente pelo banner.
    setAllPagesSelected(false);
    if (e.target.checked) {
      setActive(true);
      setCheckedState(new Array(leads.length).fill(true));
      setChecked(
        leads.map((item) => ({
          idLead: item.idLead,
          idLeadCorretor: item.idLeadCorretor,
        }))
      );
    } else {
      setActive(false);
      setChecked([]);
      setCheckedState(new Array(leads.length).fill(false));
    }
  };

  const selectAllPages = () => {
    setAllPagesSelected(true);
  };

  const clearAllPages = () => {
    setAllPagesSelected(false);
  };

  const resetSelection = () => {
    setChecked([]);
    setCheckedState(new Array(leads.length).fill(false));
    setActive(false);
    setAllPagesSelected(false);
  };

  return {
    active,
    checked,
    checkedState,
    allPagesSelected,
    addRemoveCheck,
    handleCheckAll,
    selectAllPages,
    clearAllPages,
    resetSelection,
  };
}
